import christmasBadge from '../assets/images/badges/christmas.svg';
import commutingBadge1 from '../assets/images/badges/commuting/1.svg';
import commutingBadge2 from '../assets/images/badges/commuting/2.svg';
import commutingBadge3 from '../assets/images/badges/commuting/3.svg';
import commutingBadge4 from '../assets/images/badges/commuting/4.svg';
import commutingBadge5 from '../assets/images/badges/commuting/5.svg';
import commutingBadge6 from '../assets/images/badges/commuting/6.svg';
import commutingBadge7 from '../assets/images/badges/commuting/7.svg';
import consecutiveDaysBadge1 from '../assets/images/badges/consecutive-days/1.svg';
import consecutiveDaysBadge2 from '../assets/images/badges/consecutive-days/2.svg';
import consecutiveDaysBadge3 from '../assets/images/badges/consecutive-days/3.svg';
import consecutiveDaysBadge4 from '../assets/images/badges/consecutive-days/4.svg';
import consecutiveDaysBadge5 from '../assets/images/badges/consecutive-days/5.svg';
import consecutiveDaysBadge6 from '../assets/images/badges/consecutive-days/6.svg';
import consecutiveDaysBadge7 from '../assets/images/badges/consecutive-days/7.svg';
import contributorBadge1 from '../assets/images/badges/contributor/1.svg';
import contributorBadge2 from '../assets/images/badges/contributor/2.svg';
import contributorBadge3 from '../assets/images/badges/contributor/3.svg';
import contributorBadge4 from '../assets/images/badges/contributor/4.svg';
import contributorBadge5 from '../assets/images/badges/contributor/5.svg';
import contributorBadge6 from '../assets/images/badges/contributor/6.svg';
import distanceBadge1 from '../assets/images/badges/distance/1.svg';
import distanceBadge2 from '../assets/images/badges/distance/2.svg';
import distanceBadge3 from '../assets/images/badges/distance/3.svg';
import distanceBadge4 from '../assets/images/badges/distance/4.svg';
import distanceBadge5 from '../assets/images/badges/distance/5.svg';
import distanceBadge6 from '../assets/images/badges/distance/6.svg';
import endOfTheYearBadge from '../assets/images/badges/end-of-the-year.svg';
import exploredH3ZonesBadge1 from '../assets/images/badges/explored-h3-zones/1.svg';
import exploredH3ZonesBadge2 from '../assets/images/badges/explored-h3-zones/2.svg';
import exploredH3ZonesBadge3 from '../assets/images/badges/explored-h3-zones/3.svg';
import exploredH3ZonesBadge4 from '../assets/images/badges/explored-h3-zones/4.svg';
import exploredH3ZonesBadge5 from '../assets/images/badges/explored-h3-zones/5.svg';
import exploredH3ZonesBadge6 from '../assets/images/badges/explored-h3-zones/6.svg';
import firstOfTheYearBadge from '../assets/images/badges/first-of-the-year.svg';
import halloweenBadge from '../assets/images/badges/halloween.svg';
import longDistanceIcon from '../assets/images/badges/long-distance-icon.svg';
import longDistanceBadge from '../assets/images/badges/long-distance.svg';
import maiAVeloBadge from '../assets/images/badges/mai-a-velo.svg';
import nightBirdBadge1 from '../assets/images/badges/night-bird/1.svg';
import nightBirdBadge2 from '../assets/images/badges/night-bird/2.svg';
import nightBirdBadge3 from '../assets/images/badges/night-bird/3.svg';
import nightBirdBadge4 from '../assets/images/badges/night-bird/4.svg';
import nightBirdBadge5 from '../assets/images/badges/night-bird/5.svg';
import nightBirdBadge6 from '../assets/images/badges/night-bird/6.svg';
import nightBirdBadge7 from '../assets/images/badges/night-bird/7.svg';
import nightBirdIcon from '../assets/images/badges/night-bird-icon.svg';
import nightBirdBadge from '../assets/images/badges/night-bird.svg';
import regularityBadge from '../assets/images/badges/regularity.svg';
import verticalGainBadge1 from '../assets/images/badges/vertical-gain/1.svg';
import verticalGainBadge2 from '../assets/images/badges/vertical-gain/2.svg';
import verticalGainBadge3 from '../assets/images/badges/vertical-gain/3.svg';
import verticalGainBadge4 from '../assets/images/badges/vertical-gain/4.svg';
import verticalGainBadge5 from '../assets/images/badges/vertical-gain/5.svg';
import verticalGainBadge6 from '../assets/images/badges/vertical-gain/6.svg';
import verticalGainIcon from '../assets/images/badges/vertical-gain-icon.svg';
import verticalGainBadge from '../assets/images/badges/vertical-gain.svg';
export const badgeLevels = [
// 'cyclingDistance',
'cyclingMaxDistance', 'nightBird', 'commutingTracesMaxCountOverOneMonth', 'consecutiveDays', 'verticalGain',
// 'regularity',
// 'cyclingMaxDistanceOverOneMonth',
'exploredH3Zones', 'contributor'];
export const badgeLevelsMap = {
  /* cyclingDistance: {
    bgColor: '#FFECA9',
    color: '#BB8A1A',
    image: distanceBadge,
    labelKey: 'commons.achievements.badge_titles.cycling_distance',
    progressKey: 'commons.achievements.progress.cycling_distance',
  }, */
  /* regularity: {
    bgColor: '#CDF5E3',
    color: '#048760',
    image: regularityBadge,
    labelKey: 'commons.achievements.badge_titles.regularity',
    progressKey: 'commons.achievements.progress.regularity',
  }, */
  contributor: {
    bgColor: '#FFDCC1',
    color: '#C14F0E',
    images: [contributorBadge1, contributorBadge2, contributorBadge3, contributorBadge4, contributorBadge5, contributorBadge6],
    labelKey: 'commons.achievements.badge_titles.contributor',
    progressKey: 'commons.achievements.progress.contributor'
  },
  cyclingMaxDistance: {
    bgColor: '#FFECA9',
    color: '#BB8A1A',
    images: [distanceBadge1, distanceBadge2, distanceBadge3, distanceBadge4, distanceBadge5, distanceBadge6],
    labelKey: 'commons.achievements.badge_titles.cycling_max_distance',
    progressKey: 'commons.achievements.progress.cycling_max_distance'
  },
  nightBird: {
    bgColor: '#D7C7F6',
    color: '#491EA1',
    images: [nightBirdBadge1, nightBirdBadge2, nightBirdBadge3, nightBirdBadge4, nightBirdBadge5, nightBirdBadge6, nightBirdBadge7],
    labelKey: 'commons.achievements.badge_titles.night_bird',
    progressKey: 'commons.achievements.progress.night_bird'
  },
  verticalGain: {
    bgColor: '#C9E9F8',
    color: '#006692',
    images: [verticalGainBadge1, verticalGainBadge2, verticalGainBadge3, verticalGainBadge4, verticalGainBadge5, verticalGainBadge6],
    labelKey: 'commons.achievements.badge_titles.vertical_gain',
    progressKey: 'commons.achievements.progress.vertical_gain'
  },
  cyclingMaxDistanceOverOneMonth: {
    bgColor: '#CDF5E3',
    color: '#048760',
    images: [regularityBadge],
    labelKey: 'commons.achievements.badge_titles.cycling_max_distance_over_one_month',
    progressKey: ''
  },
  commutingTracesMaxCountOverOneMonth: {
    bgColor: '#FFD7D7',
    color: '#A32828',
    images: [commutingBadge1, commutingBadge2, commutingBadge3, commutingBadge4, commutingBadge5, commutingBadge6, commutingBadge7],
    labelKey: 'commons.achievements.badge_titles.commuting_traces_max_count_over_one_month',
    progressKey: 'commons.achievements.progress.commuting_traces_max_count_over_one_month'
  },
  consecutiveDays: {
    bgColor: '#ffeca9',
    color: '#bb8a1a',
    images: [consecutiveDaysBadge1, consecutiveDaysBadge2, consecutiveDaysBadge3, consecutiveDaysBadge4, consecutiveDaysBadge5, consecutiveDaysBadge6, consecutiveDaysBadge7],
    labelKey: 'commons.achievements.badge_titles.consecutive_days',
    progressKey: 'commons.achievements.progress.consecutive_days'
  },
  exploredH3Zones: {
    bgColor: '#c9e9f8',
    color: '#006692',
    images: [exploredH3ZonesBadge1, exploredH3ZonesBadge2, exploredH3ZonesBadge3, exploredH3ZonesBadge4, exploredH3ZonesBadge5, exploredH3ZonesBadge6],
    labelKey: 'commons.achievements.badge_titles.explored_h3_zones',
    progressKey: 'commons.achievements.progress.explored_h3_zones'
  }
};
export const conditionalBadges = ['verticalGain', 'longDistance', 'nightBird'];
export const conditionalBadgesMap = {
  longDistance: {
    bgColor: '#FFDCC1',
    color: '#C14F0E',
    image: longDistanceBadge,
    icon: longDistanceIcon,
    labelKey: 'commons.achievements.badge_titles.long_distance',
    progressKey: 'commons.achievements.progress.long_distance'
  },
  nightBird: {
    bgColor: '#D7C7F6',
    color: '#491EA1',
    image: nightBirdBadge,
    icon: nightBirdIcon,
    labelKey: 'commons.achievements.badge_titles.night_bird',
    progressKey: 'commons.achievements.progress.night_bird'
  },
  verticalGain: {
    bgColor: '#C9E9F8',
    color: '#006692',
    image: verticalGainBadge,
    icon: verticalGainIcon,
    labelKey: 'commons.achievements.badge_titles.vertical_gain',
    progressKey: 'commons.achievements.progress.vertical_gain'
  }
};
export const dayBadges = ['HALLOWEEN', 'CHRISTMAS_DAY', 'NEW_YEARS_EVE', 'NEW_YEARS_DAY', 'MAI_A_VELO'];
export const dayBadgesMap = {
  HALLOWEEN: {
    bgColor: '#D7C7F6',
    color: '#491EA1',
    image: halloweenBadge,
    labelKey: 'commons.achievements.badge_titles.halloween',
    descriptionKey: 'commons.achievements.badge_descriptions.halloween'
  },
  CHRISTMAS_DAY: {
    bgColor: '#FFDCC1',
    color: '#C14F0E',
    image: christmasBadge,
    labelKey: 'commons.achievements.badge_titles.christmas_day',
    descriptionKey: 'commons.achievements.badge_descriptions.christmas_day'
  },
  NEW_YEARS_EVE: {
    bgColor: '#CDF5E3',
    color: '#048760',
    image: endOfTheYearBadge,
    labelKey: 'commons.achievements.badge_titles.new_year_eve',
    descriptionKey: 'commons.achievements.badge_descriptions.new_year_eve'
  },
  NEW_YEARS_DAY: {
    bgColor: '#FFEBF5',
    color: '#C6377C',
    image: firstOfTheYearBadge,
    labelKey: 'commons.achievements.badge_titles.new_year_day',
    descriptionKey: 'commons.achievements.badge_descriptions.new_year_day'
  },
  MAI_A_VELO: {
    bgColor: '#FFECA9',
    color: '#BB8A1A',
    image: maiAVeloBadge,
    labelKey: 'commons.achievements.badge_titles.mai_a_velo',
    descriptionKey: 'commons.achievements.badge_descriptions.mai_a_velo'
  }
};